import { useLogger } from "@sg-protect/federation-runtime/squide";
import { InternalServerError, MixpanelPropertiesProvider, MixpanelProperty } from "@sg-protect/shell";
import config from "@sg-protect/runtime-config";
import { type ErrorInfo, type PropsWithChildren, useCallback, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { AutomaticTelemetryInitializer } from "../../utils/automatic-tracking/AutomaticTelemetryInitializer.tsx";

const MigrateSource = {
    [MixpanelProperty.Source]: "ShareGate Migrate"
};

/**
 * This provider is used for both public and private pages
 */
export function GlobalProviders({ children }: PropsWithChildren) {
    const logger = useLogger();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = "ShareGate | Migration Assessment";

        return () => {
            document.title = previousTitle;
        };
    }, []);

    const handleError = useCallback(
        (error: unknown, info: ErrorInfo) => {
            logger
                .withText("[migrate] ErrorBoundary caught an error")
                .withError(error as Error)
                .withObject(info)
                .error();
        },
        [logger]
    );

    return (
        <ErrorBoundary fallback={<InternalServerError homeUrl={config.get().home.baseUrl} />} onError={handleError}>
            <MixpanelPropertiesProvider value={MigrateSource}>
                {children}
                <AutomaticTelemetryInitializer />
            </MixpanelPropertiesProvider>
        </ErrorBoundary>
    );
}
